
    export default {
        name: 'CompanySlide',

        props: {
            img: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                interval: '',
                slideDuration: 2000,
                current: 0,
                previous: 0,
            };
        },

        mounted() {
            this.slides = this.$el.getElementsByTagName('img');
            this.previous = this.slides.length - 1;

            if (this.img.length) {
                this.animate();
                this.initSlide();
            }
        },

        beforeDestroy() {
            clearInterval(this.interval);
        },

        methods: {
            initSlide() {
                this.interval = setInterval(this.animate, this.slideDuration);
            },

            animate() {
                this.previous = this.current === 0 ? this.slides.length - 1 : this.current - 1;

                this.$velocity(this.slides[this.current], 'fadeIn', { duration: this.slideDuration, mobileHA: false });
                this.$velocity(this.slides[this.previous], 'fadeOut', { duration: this.slideDuration, mobileHA: false });

                this.current = this.current !== this.slides.length - 1 ? this.current + 1 : 0;
            },
        },
    };
